import Vue from "vue"

import Autocomplete from "./components/Autocomplete"
import Availabilities from "./components/Availabilities"
import Cacher from "./components/Cacher"
import DateTimePicker from "./components/DateTimePicker"
import FormActions from "./components/FormActions"
import GenericList from "./components/GenericList"
import GenericCreate from "./components/GenericCreate"
import GenericUpdate from "./components/GenericUpdate"
import GenericUpdateList from "./components/GenericUpdateList"
import StatusIndicator from "./components/StatusIndicator"
import TimeAgo from "./components/TimeAgo"

Vue.component("Autocomplete", Autocomplete)
Vue.component("Availabilities", Availabilities)
Vue.component("Cacher", Cacher)
Vue.component("DateTimePicker", DateTimePicker)
Vue.component("FormActions", FormActions)
Vue.component("GenericList", GenericList)
Vue.component("GenericCreate", GenericCreate)
Vue.component("GenericUpdate", GenericUpdate)
Vue.component("GenericUpdateList", GenericUpdateList)
Vue.component("StatusIndicator", StatusIndicator)
Vue.component("TimeAgo", TimeAgo)
